import { render, staticRenderFns } from "./OnlineSessionIndex.vue?vue&type=template&id=dc135d8e&scoped=true&"
import script from "./OnlineSessionIndex.vue?vue&type=script&lang=js&"
export * from "./OnlineSessionIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc135d8e",
  null
  
)

export default component.exports